import { Pipe, PipeTransform } from '@angular/core';
import { CommonUtil } from 'src/app/core/Utils/common-util';

@Pipe({
  name: 'kmMi'
})
export class KmMiPipe implements PipeTransform {
  constructor(private commonUtil: CommonUtil){
  }
  
  transform(value: any,uom: string): string {
    let transformedValue = "";
    let KILOMETERS_IN_MILE = 1.609;
    if(uom === 'M'){
      transformedValue = Math.round(Number(value) * KILOMETERS_IN_MILE) + " "+ this.commonUtil.translateText('KM');
    }else{
      transformedValue = Math.round(Number(value)) + " "+ this.commonUtil.translateText('MI');
    } 
    return transformedValue;
  }
}
